<template>
	<div>{{ value.title }}</div>
</template>

<script lang="ts" setup>
import {EventdateInterface} from "@/js/interfaces/eventdate"

defineProps<{
	value: EventdateInterface
}>()
</script>
